module.exports = "/images/joyride-logo.png";